module.exports = __webpack_public_path__ + "img/Character_Xingqiu_Thumb.4ee7dbc1.png";